module.exports = {
  noResult: 'គ្មានលទ្ធផល',
  selected: 'បានជ្រើសរើស',
  unseleted: 'មិនជ្រើសរើស',
  productManager: 'ការគ្រប់គ្រងទំនិញ',
  productInfo: 'ព័ត៌មានអំពីទំនិញ',
  duplicateSpecificationNameErrorTips: 'ការបញ្ជាក់ពីឈ្មោះធ្វើម្តងទៀត',
  selectedProduct: 'ធាតុដែលបានជ្រើសរើស ({args1})',
  startTimeNotMoreThanEndTime: 'ពេលវេលាចាប់ផ្តើមមិនអាចធំជាងម៉ោងបញ្ចប់បានទេ។',
  managerMenu: 'គ្រប់គ្រងម៉ឺនុយ',
  productMenu: 'ម៉ឺនុយផលិតផល',
  menu: 'ម៉ឺនុយ',
  pleaseCheckProduct: 'សូមគូសផលិតផលជាមុនសិន',
  dragSort: 'តម្រៀបដែលអាចអូសបាន',
  addClassification: 'បន្ថែមប្រភេទ',
  addProduct: 'ការបន្ថែមទំនិញ',
  editProduct: 'កែសម្រួលផលិតផល',
  sort: 'តម្រៀប',
  productSort: 'ទំនិញតម្រៀប',
  menuName: 'ឈ្មោះម៉ឺនុយ',
  menuId: 'ម៉ឺនុយ ID',
  classificationShow: 'ការកំណត់ការបង្ហាញ',
  productNum: 'ចំនួនទំនិញ',
  checkMenuTips: 'សូមពិនិត្យមើលយ៉ាងហោចណាស់ធាតុម៉ឺនុយមួយ។!',
  confirmBatchDelMenu: 'តើ​អ្នក​ប្រាកដ​ជា​លុប​ម៉ឺនុយ {args1}',
  noMenuId: 'បង្កើតដោយស្វ័យប្រវត្តិដោយប្រព័ន្ធ',
  every: 'រាល់',
  classfications: 'ប្រភេទ',
  classfication: 'តារាប្រភេទ',
  all: 'ទាំងអស់',
  addOrEdit: 'បន្ថែមទៅ/កែប្រែទំនិញ',
  productList: 'តារាងទំនិញ',
  productName: 'ឈ្មោះទំនិញ',
  productStatus: 'ស្ថានភាពស្តុក',
  salesStatus: 'ស្ថានភាពការលក់',
  activityStatus: 'ស្ថានភាពប្រម៉ូសិន',
  soldOut: 'អស់ស្ដុក',
  inStock: 'មានស្តុក',
  productID: 'ទំនិញID',
  everyDay: 'ជារៀងរាល់ថ្ងៃ',
  pleaseInputProductCategory: 'សូមបញ្ចូលប្រភេទទំនិញ',
  productPrice: 'ការបញ្ជាក់ពីតម្លៃ',
  lunchBoxFee: 'សេវាវេចខ្ចប់',
  stock: 'ក្នុងស្តុក',
  salesMount: 'ការលក់',
  activityDiscount: 'ប្រម៉ូសិនបញ្ចុះតម្លៃ',
  onShelf: 'មានស្តុក',
  unShelf: 'មិនមានស្តុក',
  discount: 'បញ្ចុះតម្លៃ',
  productImage: 'រូបភាពទំនិញ',
  noLink: 'មិនជាប់ពាក់ព័ន្ធ',
  toZero: 'លក់អស់',
  salesRaking: 'តម្រៀបចំនួនលក់',
  productDesc: 'ការពិពណ៌នាអំពីទំនិញ',
  newProduct: 'ទំនិញថ្មី',
  deleteProduct: 'តើអ្នកប្រាកដក្នុងការលុបផលិតផលចំនួន {args1} មែនទេ?',
  zeroProduct: 'លក់អស់,តើអ្នកយល់ព្រមទេ？',
  linkStatus: 'កាលវិភាគព្រឹត្តិការណ៍',
  productSpecification: 'ំនិញប្រភេទនៃ',
  productAttr: 'ទំនិញគុណលក្ខណៈ',
  currentInventory: 'ស្តុកបច្ចុប្បន្ន',
  full: 'ពេញ',
  autoFull: 'បំពេញដោយស្វ័យប្រវត្តិ',
  dailyAutoFull: 'ស្តុកពេញដោយស្វ័យប្រវិត្តិរៀងរាល់ម៉ោង4:00',
  maxValue: 'ស្តុកអតិបរមា',
  addSpecification: 'បន្ថែមការបញ្ជាក់',
  specification: 'ការបញ្ជាក់',
  productPrice: 'តម្លៃទំនិញ',
  addAttributes: 'បន្ថែមជម្រើស',
  attributesName: 'ឈ្មោះធាតុផ្សំ',
  attributesConfig: 'ការកំណត់ធាតុផ្សំ',
  option: 'ជម្រើស',
  markUp: 'បូកតម្លៃ',
  RequiredItem: 'ទាមទារត្រូវការជ្រើសរើស',
  item: 'ជម្រើស',
  optionalItem: 'Optional Most Select',
  productDiscount: 'Item Promotions',
  hotProduct: 'Special Offer',
  explosiveProductPrice: 'hot Sale',
  noTranslate: 'Not Translated',
  setLunchBox: 'ថាតើត្រូវកំណត់ថ្លៃប្រអប់អាហារថ្ងៃត្រង់ឬអត់',
  lunchBoxContent: 'កំណត់តំលៃប្រអប់អាហារអាចប៉ះពាល់ដល់អតិថិជនបញ្ជាទិញ ប្រាកដដែររឺទេ?',
  noSelectCategory: 'បមិន​បាន​កំណត់​ម៉ឺនុយ​ផលិតផល, ដាក់​ស្នើ?',
  importType: 'ប្រភេទចាក់ចូល',
  onlyInsertData: 'បង្កើតទិន្នន័យ',
  onlyUpdateData: 'ទិន្នន័យកំណែថ្មី',
  reSelect: 'ជ្រើសរើសម្តងទៀត',
  selectFile: 'ជ្រើសរើសទិន្នន័យ',
  illustrate: 'គន្លឹះ៖',
  illustrate1: '1. ឯកសារចាក់ចូលបានតែ​ .xlsx；',
  illustrate2: '2. ទិន្នន័យដែលចាក់ចូលត្រូវនៅទំព័រទីមួយ​；',
  illustrate3: '3. ពេលកំណែទិន្នន័យថ្មី​ សូមចាក់ទិន្នន័យដែលមាន​លេខសម្គាល់​ កែប្រែរួច បន្ទាប់មកចាក់ទិន្នន័យចូលវិញ (ត្រូវមានលេខសម្គាល់)；',
  illustrate4: '4. ទំនិញដែលចាក់ចូលមិនអាចលើសពី​ 1000 ទំនិញ។ ប្រសិនបើទំនិញច្រើន សូមបែកចែកឯកសារដើម្បីចាក់ចូល។；',
  illustrate5: '5. កំណែថ្មីដែចាក់ចូលមិនអាចត្រលប់ក្រោយបាន សូមធ្វើដោយប្រុងប្រយត្ន័។；',
  downloadImportTemplate: 'ទាញយកគំរូចាក់ចូល',
  startImport: 'ចាប់ផ្តើមចាក់ចូល',
  productStock: 'ភាគហ៊ុន​ទំនិញ',
  specificationName: 'ឈ្មោះជាក់លាក់',
  barCode: 'បាកូដ',
  dataImport: 'ចាក់ទិន្នន័យចូល',
  loadingImportTips: "កំពុងនាំចូលបំណែកទិន្នន័យ {len}",
  dataValid: 'ពិនិត្យទិន្នន័យ',
  loadingValid: 'កំពុងពិនិត្យ',
  dataImportSuccess: 'ចាក់ទិន្នន័យចូល​ជោគជ័យ​',
  importException: 'ការនាំចូលបានអស់ពេល ឬមានករណីលើកលែងកើតឡើង',
  dataIsEmpty: "ទិន្នន័យគឺទទេ",
  dataImportFailed: "ចាក់ទិន្នន័យចូល​បរាជ័យ",
  importReminder: "ក្រើនរំលឹកចាក់ចូល",
  bigSize: 'លើសពីបន្ទាត់នាំចូលអតិបរមានៃ 1000',
  fileIsEmpty: 'ឯកសារគឺទទេ',
  storeDoesNotExist: "ហាងមិនមានទេ។",
  unknownMistake: "កំហុសមិនស្គាល់",
  dataCanBeImported: "ទិន្នន័យត្រឹមត្រូវ",
  unableToImportData: "មិនអាចចាក់់ទិន្នន័យចូលបាន",
  downloadWrongData: "ទាញយកទិន្នន័យខុស",
  importTemplateError: 'ខុសគំរូចាក់ចូល',
  importOnlyCorrectData: "ទិន្នន័យចាក់ចូលត្រឹមត្រូវ",
  failedToGetStoreInformation: 'បរាជ័យក្នុងការទទួលបានព័ត៌មានហាង',
  importTimeout: "អស់ពេលវេលាពិនិត្យទិន្នន័យ។សូមកាត់បន្ថយទិន្នន័យ រឺបែងចែកទិន្នន័យ",
  productSelectLimit: "ជ្រើសរើសដែនកំណត់ខាងលើនៃ 1000",
  productNameMust: "ឈ្មោះផលិតផលត្រូវតែមានយ៉ាងហោចណាស់មួយភាសា",
  productCategory: "ប្រភេទទំនិញ",
  selectProductCategory: "ជ្រើសរើសប្រភេទទំនិញ",
  productCategoryList: "តារាង​ប្រភេទទំនិញ",
  selectedCategory: "សូមគូសប្រភេទមួយ។！",
  pendingDataNotExist: "ទិន្នន័យដែលត្រូវអាប់ដេតលែងមានទៀតហើយ",
  itemCharge: 'Item charge',
  enableMultiCharge: 'បគិតតំលៃលើទំនិញច្រើន',
  dynamicCal: 'តំលៃវេចខ្ចប់និងប្រែប្រួលទៅតាមចំនួនទំនិញ។',
  example: 'ឧទាហរណ៍',
  per3Item: '$1 សម្រាប់រាល់ទំនិញទាំងបី',
  userBuyChargedOne$: 'នៅពេលអ្នកប្រើប្រាស់ទិញទំនិញពី 1 ទៅ 3 មុខ 1 ដុល្លារនឹងត្រូវគិតថ្លៃ;',
  userBuyChargedTwo$: 'នៅពេលអ្នកប្រើប្រាស់ទិញទំនិញពី 4 ទៅ 6 មុខ 2 ដុល្លារនឹងត្រូវគិតថ្លៃ，',
  andSoOn: 'ហើយដូច្នេះនៅលើ',
  packageFee: 'ថ្លៃវេចខ្ចប់',
  importActualNumLarge1000: 'ផ្ទុកឡើងបរិមាណជាក់ស្តែងគឺលើសពី 1000',
  dataChanges: 'ទិន្នន័យការផ្លាស់ប្តូរ',
  existJoinedActivityProduct: 'ផលិតផលដែលបានចូលរួមក្នុងព្រឹត្តិការណ៍មិនអាចលុបបានទេ!',
  existJoinedActivityProductSingle: 'ធាតុនេះបានចូលរួមក្នុងព្រឹត្តិការណ៍រួចហើយ សូមចាកចេញពីព្រឹត្តិការណ៍ ហើយព្យាយាមម្តងទៀត!',
  updateType: 'ប្រភេទធ្វើឱ្យទាន់សម័យ',
  overbigsize: 'លើសទិន្នន័យ នឹងចាក់ចេញបានទិន្នន័យដំបូង​2000',
  productTopicActivity: 'ទំនិញការផ្តល់ជូនប្រធានបទសកម្មភាព',
  storeRecommendation: 'ម្ចាស់ហាងណែនាំ',
  storeRecommendationOverTips: 'មានផលិតផលចំនួន 5 ដែលត្រូវបានណែនាំដោយអ្នកគ្រប់គ្រងហាងរួចហើយ សូមសម្អាត រួចរៀបចំ',
  sortTips: 'ការតម្រៀបគឺអាចធ្វើទៅបានបន្ទាប់ពីជ្រើសរើសម៉ឺនុយ',
  uploadImgTip:"កំពុងបង្ហោះ {num} ​ រូបភាព​",
  productImg:"រូបមីនុយ​",
  matchMethod:"វិធីផ្គូរផ្គង:",
  selectMatchMethod:"សូមជ្រើសរើសវិធីផ្គូរផ្គង​",
  pleaseUploadPic:"សូមបង្ហោះរូបភាព",
  uploadFailTip:"បង្ហោះរូបភាពបរាជ័យ",
  downloadFailData:"ទាញយកទិន្នន័យបរាជ័យ",
  uploadComplete:"បង្ហោះរូបភាពជោគជ័យ​",
  success:"ជោគជ័យ​",
  fail:"បរាជ័យ",
  batchUploadPictures:"បង្ហោះរូបភាពជាបណ្តុំ​",
  MenuPreview: "មើលមីនុយជាមុន​",
  MenuType:"ប្រភេទម៉ឺនុយ",
  upload: "ផ្ទុកឡើង",
  Prodcutdiscount: 'មីនុយបញ្ចុះតំលៃ​',
  NormalMenu: 'មីនុយធម្មតា​',
  BestsellMenu: 'មីនុយលក់ដាច់',
  RecommendMenu: 'ម៉ឺនុយដែលបានណែនាំ',
  SOPMenu: 'SOP មីនុយ',
}
